export const translations = {

  /*** COMMON ***/
  APPLE_STORE: "Apple store",
  PLAY_STORE: "Play store",
  /* NAV_BAR */
  SO_APP: "SoApp",
  OUR_MISSION: "Our Mission",
  EU_REGULATIONS: "EU Regulations",
  ABOUT_US: "About Us",
  SUPPORT_US: "Support Us",
  CONTACT: "Contact",
  EMAIL: "Email",
  SIGN_UP: "Sign Up",
  /* SIGN_UP SECTION*/
  SIGN_UP_SECTION_SUBTITLE: "News letter",
  SIGN_UP_SECTION_TITLE: "Sign up to stay updated on all the latest news.",
  /* STORE SECTION */
  STORE_SECTION_TITLE: "Be part of the change",
  SEND_EMAIL: "Send Email",
  SUBMIT: "Submit",

  /*** HOME ***/
  /* HOME - Main Header */
  MAIN_HEADER_TITLE_PART_1: "Revisit the way you",
  MAIN_HEADER_TITLE_PART_2: "interact",
  MAIN_HEADER_TITLE_PART_3: "with your groups.",
  MAIN_HEADER_SUBTITLE: "Your connections, your data, your control",
  /* HOME - Module */
  //Module 1 TItle
  MODULE_1_TITLE_1: "Group-Centric",
  MODULE_1_TITLE_2: "Communication",
  //Module 1 Subtitle
  MODULE_1_SUBTITLE: "SoApp is designed for seamless group interactions whether for friends, events, class or business.",
  //Module 2 Title
  MODULE_2_TITLE_1: "Event",
  MODULE_2_TITLE_2: "organisation",
  MODULE_2_TITLE_3: "and",
  MODULE_2_TITLE_4: "management",
  //Module 1 Subtitle
  MODULE_2_SUBTITLE: "Create events, merge events, invite friends & create lasting memories together for all.",
  //Module 3 Title
  MODULE_3_TITLE_1: "Cost",
  MODULE_3_TITLE_2: "sharing",
  MODULE_3_TITLE_3: "&",
  MODULE_3_TITLE_4: "fund",
  MODULE_3_TITLE_5: "managing",
  //Module 1 Subtitle
  MODULE_3_SUBTITLE: "Manage group expenses effortlessly, track spending and split costs transparently, ",
  //Module 4 Title
  MODULE_4_TITLE_1: "Share Across",
  MODULE_4_TITLE_2: "all",
  MODULE_4_TITLE_3: "your",
  MODULE_4_TITLE_4: "favourite",
  MODULE_4_TITLE_5: "platforms!",
  //Module 1 Subtitle
  MODULE_4_SUBTITLE: "Easily share pictures, messages, videos, projects and events across you favourite platforms.",
  /* HOME - Blue&Cartel */
  //Blue Background
  HOME_BLUE_CARTEL_SUBTITLE: "The mission",
  HOME_BLUE_CARTEL_TITLE: "The new data driven circular economy",
  HOME_BLUE_CARTEL_BUTTON: "Learn more",
  //Cartels
  HOME_BLUE_CARTEL_TITLE_1: "Your data, your asset",
  HOME_BLUE_CARTEL_DESCRIPTION_1: "Unlike traditional social platforms, SoApp ensures that all data belongs to the user. This means you can monetize your digital footprint while retaining control.",
  HOME_BLUE_CARTEL_TITLE_2: "Generating value from activity",
  HOME_BLUE_CARTEL_DESCRIPTION_2: "Every actions within SoApp (Sharing, event creation, interactions) contributes to your DataClone, a valuable dataset that can be sold to companies, researchers, AI developers and even other users!",
  HOME_BLUE_CARTEL_TITLE_3: "Scaling the economy",
  HOME_BLUE_CARTEL_DESCRIPTION_3: "As more users generate data, the ecosystem grows. Higher-quality, richer data sets become more valuable, allowing users to price and sell their data as they see fit!.",
  /* HOME - Mozaic */
  //Header
  HOME_MOZAIC_SUBTITLE: "What's next",
  HOME_MOZAIC_TITLE_1: "Our future",
  HOME_MOZAIC_TITLE_2: "features",
  //Mozaic Text
  HOME_MOZAIC_ITEM_TITLE_1: "SoApp Sandbox",
  HOME_MOZAIC_ITEM_DESCRIPTION_1: "Turning our features into APIs to be exported, Enabling you to build and turn SoApp into whatever you want!",
  HOME_MOZAIC_ITEM_TITLE_2: "Geofenced Experiences & Content",
  HOME_MOZAIC_ITEM_DESCRIPTION_2: "Geo-fence your event to ensure seamless sharing of content and experiences with the event and its guests!",
  HOME_MOZAIC_ITEM_TITLE_3: "Live Multi-Camera Content Creation",
  HOME_MOZAIC_ITEM_DESCRIPTION_3: "Create unforgetful memories by creating videos from multiple angles live!",
  HOME_MOZAIC_ITEM_TITLE_4: "Travels Marketplace",
  HOME_MOZAIC_ITEM_DESCRIPTION_4: "Putting “Social” back in Social Media: By using SoApp to travel, you can then propose your experience to the rest of the community on our marketplace.",
  HOME_MOZAIC_ITEM_TITLE_5: "Change Perspective",
  HOME_MOZAIC_ITEM_DESCRIPTION_5: "Change your experience of SoApp by changing perspective through the use of DataClones. Check out our mission to know more!",
  HOME_MOZAIC_ITEM_TITLE_6: "Privacy & Smart Data Controls",
  HOME_MOZAIC_ITEM_DESCRIPTION_6: "Fine-tune & calibrate your experience of SoApp. You then decide if you want to earn from the data you generate or keep it private!",
  HOME_MOZAIC_ITEM_TITLE_7: "The SoApp Login",
  HOME_MOZAIC_ITEM_DESCRIPTION_7: "SoApp wants to be the best way you can login anywhere. Login in with SoApp will enable you to truly benefit from the data you generate anywhere!",
  /* HOME - Progress Bar */
  //Progress Bar Title
  HOME_PROGRESS_BAR_SUBTITLE: "Objective",
  HOME_PROGRESS_BAR_TITLE_1: "Percentage",
  HOME_PROGRESS_BAR_TITLE_2: "before",
  HOME_PROGRESS_BAR_TITLE_3: "official release",
  //Progress Bar Body
  HOME_PROGRESS_BAR_CURRENT_STEP: "Current Step: Beta feature development",
  HOME_PROGRESS_BAR_NEXT_STEP: "Next Step: Beta testing",
  HOME_PROGRESS_BAR_BUTTON: "Support Us",

  /*** EU_REGULATION ***/
  /* EU_REGULATION - Main Title */
  EU_REGULATION_MAIN_TITLE_1: "EU",
  EU_REGULATION_MAIN_TITLE_2: "regulations",
  EU_REGULATION_MAIN_TITLE_3: "as weapons of",
  EU_REGULATION_MAIN_TITLE_4: "innovation",
  /* EU_REGULATION - Section Blue And Cartel */
  //Main Title
  EU_REGULATION_TITLE: "How the European regulations help SoApp",
  //Cartel
  EU_REGULATION_CARTEL_TITLE_1: "Digital markets act",
  EU_REGULATION_CARTEL_DESCRIPTION_1: "Access other messages from your favourite platform directly within SoApp! This ensures Cross-Platform compatibility like never before!",
  EU_REGULATION_CARTEL_TITLE_2: "AI Act",
  EU_REGULATION_CARTEL_DESCRIPTION_2: "DataClones ensure AI companies can purchase your data straight from you and at the price you set.",
  EU_REGULATION_CARTEL_TITLE_3: "GDPR",
  EU_REGULATION_CARTEL_DESCRIPTION_3: "SoApp gives you the tools to regain control over your digital footprint.",
  /* EU_REGULATION - Section Module */
  EU_REGULATION_SECTION_MODULE_TITLE_1_1: "Take",
  EU_REGULATION_SECTION_MODULE_TITLE_1_2: "back",
  EU_REGULATION_SECTION_MODULE_TITLE_1_3: "control",
  EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_1: "SoApp collects all the data generated by you and then gives you the tools to seamlessly control what you want to do with it.",
  EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_2: "Earn through the DataClone marketplace",
  EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_3: "Protect your data ",
  EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_4: "Change your perspective",
  EU_REGULATION_SECTION_MODULE_DESCRIPTION_1_5: "Control its accessibility ",
  EU_REGULATION_SECTION_MODULE_TITLE_2_1: "Accessing your",
  EU_REGULATION_SECTION_MODULE_TITLE_2_2: "favourite",
  EU_REGULATION_SECTION_MODULE_TITLE_2_3: "platforms",
  EU_REGULATION_SECTION_MODULE_DESCRIPTION_2_1: "Coming soon! The digital markets act has forced big platforms such as WhatsApp and Messenger to open their services to 3rd party platforms meaning SoApp messages can be sent and received on WhatsApp and Messenger and vice-versa!",

  /*** MISSION ***/
  /* MISSION - Main Title */
  MISSION_MAIN_TITLE_1: "Our Mission :",
  MISSION_MAIN_TITLE_2: "User-centric",
  MISSION_MAIN_TITLE_3: "Digital Empowerment",
  /* MiSSION - Blue & Cartel */
  //Title
  MISSION_CARTEL_TITLE: "You generate data every day. But who profits from it?",
  MISSION_CARTEL_SUBTITLE: "Right now, companies collect and sell your data without your consent or compensation. Your digital identity is worth more than you think. But what if you could take control?",
  //Cartel
  MISSION_CARTEL_TITLE_1_1: "Putting",
  MISSION_CARTEL_TITLE_1_2: "\"Social\"",
  MISSION_CARTEL_TITLE_1_3: "back in Social media",
  MISSION_CARTEL_DESCRIPTION_1: "SoApp isn’t just about data. It’s about breaking free from algorithms and reconnecting with real people.",
  MISSION_CARTEL_TITLE_2_1: "Use SoApp,",
  MISSION_CARTEL_TITLE_2_2: "Earn",
  MISSION_CARTEL_TITLE_2_3: "from",
  MISSION_CARTEL_TITLE_2_4: "Your Data",
  MISSION_CARTEL_DESCRIPTION_2: "Data control comes in the form of DataClones. They are an amalgamation of all your data. Sell or gift it to other users and help them escape their Algorithm-fed bubble.",
  MISSION_CARTEL_TITLE_3_1: "SoApp is your",
  MISSION_CARTEL_TITLE_3_2: "personal",
  MISSION_CARTEL_TITLE_3_3: "data wallet",
  MISSION_CARTEL_DESCRIPTION_3: "Any data you generate belongs to you, you control it. Businesses will have to buy it directly from you, not shady brokers.",

  /*** SUPPORT ***/
  /* SUPPORT - Main Title */
  SUPPORT_MAIN_TITLE_1: "Create",
  SUPPORT_MAIN_TITLE_2: "doodles",
  SUPPORT_MAIN_TITLE_3: "and donates to",
  SUPPORT_MAIN_TITLE_4: "help us",
  /* SUPPORT - Button */
  SUPPORT_MAIN_BUTTON_1: "Create a doodle",
  SUPPORT_MAIN_BUTTON_2: "Donate",
  /* SUPPORT - Module */
  SUPPORT_MODULE_CARTEL_TITLE_1: "Create your doodle",
  SUPPORT_MODULE_CARTEL_DESCRIPTION_1: "Leave your mark on SoApp Become a part of SoApp’s future",
  SUPPORT_MODULE_CARTEL_FOOTER_1_1: "Draw",
  SUPPORT_MODULE_CARTEL_FOOTER_1_2: "whatever you want and leave your mark",
  SUPPORT_MODULE_CARTEL_TITLE_2: "Donate and Submit",
  SUPPORT_MODULE_CARTEL_DESCRIPTION_2: "Your submission will be reviewed And set to soapp’s standards and rules",
  SUPPORT_MODULE_CARTEL_FOOTER_2_1: "All",
  SUPPORT_MODULE_CARTEL_FOOTER_2_2: "the donation are directly invested in SoApp",
  SUPPORT_MODULE_CARTEL_TITLE_3: "Received confirmation",
  SUPPORT_MODULE_CARTEL_DESCRIPTION_3: "Your doodle become part of SoApp’s Chat background!",
  SUPPORT_MODULE_CARTEL_FOOTER_3_1: "Congratulation",
  SUPPORT_MODULE_CARTEL_FOOTER_3_2: "you doodle is in SoApp",
  /* SUPPORT - Rules */
  SUPPORT_RULES_TITLE_1: "Donation advantages",
  SUPPORT_RULES_1_1: "All doodles will be used to create the SoApp chat background.",
  SUPPORT_RULES_1_2: "All donors (doodle or not) will be automatically pre-selected to be SoApp early bird testers, for Pre-Launch and EVERY ULTERIOR VERSIONS of SoApp.",
  SUPPORT_RULES_1_3: "All donors (doodle or not) will be automatically informed of fundraising rounds and will be presented the opportunity to participate.",
  SUPPORT_RULES_1_4: "All Donors (doodle or not) will have their names recorded in SoApp's VIP list.",
  SUPPORT_RULES_1_5: "TOP 10 Donors (doodle or not) will be personally contacted, thanked and invited to discuss the possibilities of SoApp's future with the founders.",
  SUPPORT_RULES_1_6: "TOP 5 Donors (doodle only) will have their doodles occupy central spots in the Background to be.",
  SUPPORT_RULES_TITLE_2: "Rule book",
  SUPPORT_RULES_2_1: "Draw a doodle, signature, mark. Keep it simple!",
  SUPPORT_RULES_2_2: "No politics, sex, third party copyrighted material, drugs & offensive imagery",
  SUPPORT_RULES_2_3: "All submissions will be adapted to Grey-scale or black and white lines (TBD)",
  SUPPORT_RULES_2_4: "All submissions will be subject to approval by the team.",
  SUPPORT_RULES_2_5: "All approved submissions will be used to create SoApp’s unique chat background.",
  SUPPORT_RULES_2_6: "You can import an image in SVG/PNG format",
  SUPPORT_RULES_2_7: "Size of donation will impact size of your mark on the background (TBD)",

  /*** PRIVACY POLICY ***/
  PRIVACY_POLICY_TITLE: "Privacy Policy",
  PRIVACY_POLICY_TITLE_1: "1. Data Collection",
  PRIVACY_POLICY_DESCRIPTION_1: "SoApp SAS collects personal information, including your name and email, when you donate through Stripe or contact us via email. This information is stored temporarily for processing purposes.",
  PRIVACY_POLICY_TITLE_2: "2. Use of Data",
  PRIVACY_POLICY_DESCRIPTION_2: "The personal data collected is used exclusively for processing donations and responding to inquiries. We do not share or sell your data to third parties.",
  PRIVACY_POLICY_TITLE_3: "3. Data Retention and Deletion",
  PRIVACY_POLICY_DESCRIPTION_3: "Your personal information will be stored securely and can be deleted upon request. To request the deletion of your data, please contact us at soapp@soappgroup.com.",
  PRIVACY_POLICY_TITLE_4: "4. GDPR Rights",
  PRIVACY_POLICY_DESCRIPTION_4: "If you are located in the European Union, you have the right to request access to your personal data, request its deletion, or correct any inaccuracies. To exercise these rights, contact us at soapp@soappgroup.com.",

  /*** APP PERMISSIONS ***/
  APP_PERMISSIONS_TITLE: "App permissions",

  /*** Confidentiality Agreement ***/
  CONFIDENTIALITY_AGREEMENT_TITLE: "Confidentiality & Doodle Agreement",
  CONFIDENTIALITY_AGREEMENT_TITLE_1: "1. Scope",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_1: "This Confidentiality Agreement (\"the Agreement\") governs the disclosure of confidential information that may be shared between SoApp SAS and Users who donate, submit drawings, or contact the Company.",
  CONFIDENTIALITY_AGREEMENT_TITLE_2: "2. Confidential Information",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_2: "\"Confidential Information\" refers to any information disclosed by Users or SoApp SAS, including but not limited to names, emails, payment data, drawings, and any communication between the parties.",
  CONFIDENTIALITY_AGREEMENT_TITLE_3: "3. Protection of Confidential Information",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_3: "Both parties agree to take reasonable steps to protect and safeguard Confidential Information. SoApp SAS will ensure that any personal data collected is securely stored in a Gmail account and not disclosed to third parties unless required by law.",
  CONFIDENTIALITY_AGREEMENT_TITLE_4: "4. Exclusions",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4: "The obligation to maintain confidentiality does not apply to information that:",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_1: "Is publicly available or becomes publicly available through no fault of the receiving party;",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_2: "Is received from a third party with the legal right to disclose it;",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_4_3: "Is required to be disclosed under legal obligations.",
  CONFIDENTIALITY_AGREEMENT_TITLE_5: "5. User Data Requests",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_5: "Users may request access to or deletion of their personal data at any time by contacting the Company at soapp@soappgroup.com. SoApp SAS agrees to comply with such requests in accordance with applicable data protection regulations, including the GDPR.",
  CONFIDENTIALITY_AGREEMENT_TITLE_6: "6. Term",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_6: "This Agreement remains in effect for as long as the confidential information is in possession of the receiving party. Confidentiality obligations extend beyond the termination of this Agreement.",
  CONFIDENTIALITY_AGREEMENT_TITLE_7: "7. Governing Law",
  CONFIDENTIALITY_AGREEMENT_DESCRIPTION_7: "This Agreement shall be governed by the laws of France, and any disputes will be settled in accordance with French law.",

  /*** Term Of Use ***/
  TERM_OF_USE_TITLE: "Terms of Use",
  TERM_OF_USE_TITLE_1: "1. Introduction",
  TERM_OF_USE_DESCRIPTION_1: "By accessing or using the website www.soappgroup.com (\"the Website\"), you agree to be bound by these Terms of Use. These terms apply to all visitors, users, and contributors (\"Users\"). If you do not agree to these terms, you should not use the Website.",
  TERM_OF_USE_TITLE_2: "2. Purpose",
  TERM_OF_USE_DESCRIPTION_2: "This Website showcases an application under development by SoApp SAS (\"the Company\"). Users may make non-refundable donations and submit drawings that can be used as backgrounds for the application (\"the App\").",
  TERM_OF_USE_TITLE_3: "3. Donations",
  TERM_OF_USE_DESCRIPTION_3: "Donations are processed via Stripe and are considered as support contributions, not purchases. Donations are non-refundable under any circumstances. By making a donation, you agree to provide accurate and up-to-date payment information. We collect certain personal information during the donation process, including your name, email, and data processed by Stripe.",
  TERM_OF_USE_TITLE_4: "4. User-Generated Content (Drawings)",
  TERM_OF_USE_DESCRIPTION_4_1: "Users retain ownership of the drawings submitted to the Website. However, by submitting a drawing, Users grant SoApp SAS a non-exclusive, irrevocable, royalty-free, perpetual license to use, alter, and reproduce the drawing for use as background artwork within the App and related promotional materials, free of charge.",
  TERM_OF_USE_DESCRIPTION_4_2: "Drawings may be reviewed, edited, or modified before being used. SoApp reserves the right to reject or modify any drawings that do not comply with the content guidelines outlined below.",
  TERM_OF_USE_DESCRIPTION_4_3: "Drawings must not include political messages, sexual content, references to drugs, offensive imagery, brands, or any material that infringes on third-party copyrights.",
  TERM_OF_USE_TITLE_5: "5. Contact and Personal Information",
  TERM_OF_USE_DESCRIPTION_5_1: "Users may contact the Company through the email provided on the Website. Personal data (name, email, and Stripe transaction data) will be collected when Users submit a donation or contact the team. This data is stored securely in a Gmail account and will only be retained temporarily for the purpose of processing the donation or responding to the inquiry.",
  TERM_OF_USE_DESCRIPTION_5_2: "Users have the right to request deletion of their personal data by contacting the team at soapp@soappgroup.com.",
  TERM_OF_USE_TITLE_6: "6. Intellectual Property",
  TERM_OF_USE_DESCRIPTION_6: "All content, logos, designs, and trademarks on the Website and App are the exclusive property of SoApp SAS, unless otherwise stated. Unauthorized use of these materials is prohibited.",
  TERM_OF_USE_TITLE_7: "7. Limitation of Liability",
  TERM_OF_USE_DESCRIPTION_7: "The Website is provided \"as is.\" SoApp SAS makes no warranties, either express or implied, regarding the functionality or content of the Website. The Company will not be held liable for any direct or indirect damages arising from the use of the Website or inability to access the Website.",
  TERM_OF_USE_TITLE_8: "8. Governing Law",
  TERM_OF_USE_DESCRIPTION_8: "These Terms of Use shall be governed by and construed in accordance with the laws of France. Any disputes shall be subject to the exclusive jurisdiction of the courts in France.",

    /*** DONATE FORM ***/
    DONATE_FORM_TITLE: "Donate with Purpose: Fuel Our Mission",
    //DONATE FORM - Form
    DONATE_FORM_FORM_TITLE: "Please Fill Information Below",
    DONATE_FORM_INPUT_LABEL_NAME: "Name",
    DONATE_FORM_INPUT_PLACEHOLDER_NAME: "Enter your full name",
    DONATE_FORM_INPUT_LABEL_EMAIL: "Email",
    DONATE_FORM_INPUT_PLACEHOLDER_EMAIL: "Enter email",
    DONATE_FORM_INPUT_LABEL_PHONE: "Phone Number",
    DONATE_FORM_INPUT_PLACEHOLDER_PHONE: "Enter phone",
    DONATE_FORM_ONPUT_LABEL_FIND_US: "How Did You Learn About Our Organization?",
    DONATE_FORM_ONPUT_SELECT_FIND_US_1: "Select Options",
    DONATE_FORM_ONPUT_SELECT_FIND_US_2: "Friend&Family",
    DONATE_FORM_ONPUT_SELECT_FIND_US_3: "Social Media",
    DONATE_FORM_ONPUT_SELECT_FIND_US_4: "Networking Event",
    DONATE_FORM_ONPUT_SELECT_FIND_US_5: "Other",
    DONATE_FORM_ONPUT_PLEDGE_AMOUNT: "Pledge Amount",
    DONATE_FORM_ONPUT_OTHER_AMOUNT: "Other Amount",
    DONATE_FORM_INPUT_LABEL_MESSAGE: "Message",
    DONATE_FORM_INPUT_PLACEHOLDER_MESSAGE: "Write your message here",
    DONATE_FORM_INPUT_LABEL_CREDIT_CARD: "Credit or Debit Card",
    DONATE_FORM_INPUT_PLACEHOLDER_CREADIT_CARD: "Card number",
    DONATE_FORM_INPUT_TERM_OF_USE: "Accept Terms of Use",
    //DONATE FORM - Validation
    DONATE_FORM_VALIDATION_TITLE_1: "Thank you for your generous donation",
    DONATE_FORM_VALIDATION_TITLE_2: "🎉 Congratulations on creating a doodle! 🎨",
    DONATE_FORM_VALIDATION_DESCRIPTION_1: "Your artistic expression is not only beautiful but also impactful. Every stroke of your pen contributes to positive change. Thank you for turning creativity into kindness!",
    DONATE_FORM_VALIDATION_DESCRIPTION_2: "Kindly review your inbox at",
    DONATE_FORM_VALIDATION_DESCRIPTION_3: "to access the doodle image. Thank you!",
}